import { Injectable, TemplateRef, signal } from '@angular/core';

import { CamRoutes, Menu, MenuBase, MenuIcon, MenuPanel } from '@camelot/menu';

import { EShowcaseRoute } from '../features/showcase/showcase.routes';

@Injectable({
  providedIn: 'root',
})
export class AppMenuService {
  constructor() {}

  public getMainMenu() {
    const menu = [
      new MenuIcon({
        exact: true,
        icon: 'home',
        key: 'home',
        label: 'Accueil',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase]),
        order: 1,
      }),
      new MenuIcon({
        icon: 'label',
        key: EShowcaseRoute.theme,
        label: 'Theme',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.theme]),
        order: 2,
      }),
      new MenuIcon({
        icon: 'grid',
        key: EShowcaseRoute.ui,
        label: 'UI',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.ui]),
        order: 3,
      }),
      new MenuIcon({
        icon: 'modify',
        key: EShowcaseRoute.forms,
        label: 'Forms',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.forms]),
        order: 4,
      }),
      new MenuIcon({
        icon: 'image',
        key: EShowcaseRoute.icons,
        label: 'Icons',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.icons]),
        order: 5,
      }),
      new MenuIcon({
        icon: 'layout-left-line',
        key: EShowcaseRoute.layout,
        label: 'Layout',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.layout]),
        order: 6,
      }),
      new MenuIcon({
        icon: 'listing',
        key: EShowcaseRoute.menus,
        label: 'Menus',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.menus]),
        order: 7,
      }),
      new MenuIcon({
        icon: 'notifications',
        key: EShowcaseRoute.notifications,
        label: 'Notifications',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.notifications]),
        order: 8,
      }),
      new MenuIcon({
        icon: 'mail',
        key: EShowcaseRoute.communication,
        label: 'Communication',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.communication]),
        order: 9,
      }),
      new MenuIcon({
        icon: 'folders',
        key: EShowcaseRoute.files,
        label: 'Files',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.files]),
        order: 10,
      }),
      new MenuIcon({
        icon: 'pin',
        key: EShowcaseRoute.maps,
        label: 'Maps',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.maps]),
        order: 11,
      }),
      new MenuIcon({
        icon: 'table',
        key: EShowcaseRoute.agGrid,
        label: 'AG Grid',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.agGrid]),
        order: 12,
      }),
      new MenuIcon({
        icon: 'table',
        key: EShowcaseRoute.agGridEditabled,
        label: 'AG Grid Editabled',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.agGridEditabled]),
        order: 10,
      }),
      new MenuIcon({
        icon: 'table',
        key: EShowcaseRoute.agGridEditabledQuotation,
        label: 'AG Grid Editabled Quotation',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.agGridEditabledQuotation]),
        order: 10,
      }),
      new MenuIcon({
        icon: 'send',
        key: EShowcaseRoute.webPush,
        label: 'Web Push',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.webPush]),
        order: 13,
      }),
      new MenuIcon({
        icon: 'send',
        key: EShowcaseRoute.sandboxWebPush,
        label: 'Web Push (Sandbox)',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.sandboxWebPush]),
        order: 14,
      }),
      new MenuIcon({
        icon: 'financial',
        key: EShowcaseRoute.charts,
        label: 'Charts',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.charts]),
        order: 15,
      }),
      new MenuIcon({
        icon: 'calendar',
        key: EShowcaseRoute.calendar,
        label: 'Calendar',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.calendar]),
        order: 16,
      }),
    ];

    return new Menu({
      direction: 'responsive',
      elements: menu.sort((a, b) => a.order - b.order),
    });
  }

  public getUserMenu(accountTemplate: TemplateRef<any>, notifBullet: TemplateRef<any>) {
    const menu = [
      new MenuIcon({
        icon: 'home',
        key: 'notif',
        label: 'Notification',
        order: 1,
      }),
      new MenuIcon({
        icon: 'contacts',
        key: 'account',
        label: 'Mon compte',
        options: {
          notificationBadge: {
            label: signal(5),
          },
        },
        order: 2,
      }),
      new MenuPanel({
        icon: 'contacts',
        key: 'panel',
        label: 'Testing panel',
        options: {
          extraTemplate: notifBullet,
        },
        order: 3,
        template: accountTemplate,
      }),
    ];

    return new Menu({
      direction: 'responsive',
      elements: menu.sort((a, b) => a.order - b.order),
    });
  }

  public getProfileMenu(accountTemplate: TemplateRef<any>) {
    const menu = [
      new MenuIcon({
        icon: 'home',
        key: 'notif',
        label: 'Notification',
        order: 1,
      }),
      new MenuPanel({
        icon: 'contacts',
        key: 'panel',
        label: 'Testing panel',
        order: 3,
        template: accountTemplate,
      }),
    ];

    return new Menu({
      direction: 'responsive',
      elements: menu.sort((a, b) => a.order - b.order),
    });
  }

  public getShowcaseMenu() {
    const menu = [
      new MenuBase({
        key: EShowcaseRoute.showcase,
        label: 'Overview',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase]),
        order: 1,
        replaceUrl: true,
      }),
      new MenuBase({
        key: EShowcaseRoute.theme,
        label: 'Theme',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.theme]),
        order: 2,
        replaceUrl: true,
      }),
      new MenuBase({
        key: EShowcaseRoute.ui,
        label: 'UI Components',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.ui]),
        order: 3,
        replaceUrl: true,
      }),
      new MenuBase({
        key: EShowcaseRoute.layout,
        label: 'Layouts',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.layout]),
        order: 4,
        replaceUrl: true,
      }),
      new MenuBase({
        key: EShowcaseRoute.forms,
        label: 'Forms',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.forms]),
        order: 5,
        replaceUrl: true,
      }),
      new MenuBase({
        key: EShowcaseRoute.icons,
        label: 'Icons',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.icons]),
        order: 6,
        replaceUrl: true,
      }),
      new MenuBase({
        key: EShowcaseRoute.maps,
        label: 'Maps',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.maps]),
        order: 7,
        replaceUrl: true,
      }),
      new MenuBase({
        key: EShowcaseRoute.menus,
        label: 'Menus',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.menus]),
        order: 8,
        replaceUrl: true,
      }),
      new MenuBase({
        key: EShowcaseRoute.notifications,
        label: 'Notifications',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.notifications]),
        order: 9,
        replaceUrl: true,
      }),
      new MenuBase({
        key: EShowcaseRoute.communication,
        label: 'Communication',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.communication]),
        order: 10,
        replaceUrl: true,
      }),
      new MenuBase({
        key: EShowcaseRoute.files,
        label: 'Files',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.files]),
        order: 11,
        replaceUrl: true,
      }),
      new MenuBase({
        key: EShowcaseRoute.agGrid,
        label: 'AG Grid',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.agGrid]),
        order: 12,
        replaceUrl: true,
      }),
      new MenuBase({
        key: EShowcaseRoute.agGridEditabled,
        label: 'AG Grid Editabled',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.agGridEditabled]),
        order: 10,
        replaceUrl: true,
      }),
      new MenuBase({
        key: EShowcaseRoute.agGridEditabledQuotation,
        label: 'AG Grid Editabled Quotation',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.agGridEditabledQuotation]),
        order: 10,
        replaceUrl: true,
      }),
      new MenuBase({
        key: 'webpush',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, 'webpush']),
        label: 'Web Push',
        order: 5,
      }),
      new MenuBase({
        key: EShowcaseRoute.webPush,
        label: 'Web Push',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.webPush]),
        order: 13,
        replaceUrl: true,
      }),
      new MenuBase({
        key: EShowcaseRoute.sandboxWebPush,
        label: 'Web Push (Sandbox)',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.sandboxWebPush]),
        order: 14,
        replaceUrl: true,
      }),
      new MenuBase({
        key: EShowcaseRoute.charts,
        label: 'Charts',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.charts]),
        order: 15,
        replaceUrl: true,
      }),
      new MenuBase({
        key: EShowcaseRoute.calendar,
        label: 'Calendar',
        link: CamRoutes.getAbsoluteUrl([EShowcaseRoute.showcase, EShowcaseRoute.calendar]),
        order: 16,
        replaceUrl: true,
      }),
    ];

    return new Menu({
      elements: menu.sort((a, b) => a.order - b.order),
    });
  }
}
